import { Component } from '@angular/core';
import { ActionButton } from 'src/app/models/action-footer/action-button';
import { ActionFooterService } from 'src/app/services/action-footer/action-footer.service';

@Component({
    selector: 'app-action-footer',
    templateUrl: './action-footer.component.html'
})
export class ActionFooterComponent {
    isVisible = false;
    actions: ActionButton[] = [];

    constructor(private readonly actionFooterService: ActionFooterService) {
        this.actionFooterService.getList().subscribe(actions => {
            this.actions = [...actions];
            this.isVisible = this.actions.length > 0;
        });
    }

    doAction(actionButton: ActionButton): void {
        this.actionFooterService.set({ name: actionButton.action });
    }
}
